export const VEHICLE_TYPES_MASTER_LIST = "vehicle_types_master_list"; 
export const VEHICLE_TYPES_MASTER_LIST_SUCCESSFULL = "vehicle_types_master_list_successfull";
export const CREATE_VEHICLE_TYPES_MASTER = "create_vehicle_types_master";
export const CREATE_VEHICLE_TYPES_MASTER_SUCCESSFULL = "create_vehicle_types_master_successfull";
export const UPDATE_VEHICLE_TYPES_MASTER = "update_vehicle_types_master";
export const UPDATE_VEHICLE_TYPES_MASTER_SUCCESSFULL = "update_vehicle_types_master_successfull";
export const API_ERRORS = 'api_failed';